export const METRICS_ENDPOINT = 'metrics/api/v1'
export const NETWORK_ASSET_AGGREGATION_ENDPOINT = 'network-asset-aggregation/api/v1/assets'
export const USB_SUMMARY_ENDPOINT = 'usb-inventory/api/v1/usb_devices'
export const SOFTWARE_SUMMARY_ENDPOINT = 'software-inventory/api/v1/software'
export const INCIDENTS_ENDPOINT = '/api/v1/incidentResponses'
export const USER_PREFS_URL = '/api/v1/userPreferences/vessels_beta_settings'
export const AIMEE_ENDPOINT = 'aimee/api/v1'
